Ext.namespace('utils');

utils = (function( $, Ext, window, undefined ){

	return {
		parseJSON: function (content){
			return !content ? null : Ext.decode(content);
		},
		clone: function (obj) {
			if (null == obj || "object" != typeof obj) return obj;
			var copy = obj.constructor();
			for (var attr in obj) {
				if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
			}
			return copy;
		},
		lightBox: function (id, items, width, height, title, param){
			var config;
			
			config = {
				width : width,
				height : height,
				x : '50%',
				y : '50',
				style : 'margin-left:-' + (width/2) + 'px;',
				shadow : false, 
				id : id,
				modal : true,
				resizable : false,  
				border : false,
				draggable : false,
				closeAction : 'hide'
			};
			
			if(title) config.title = title;
			if(items) config.items = items;
			if(param) config = Ext.apply(config, param);
			
			return new Ext.Window(config);
		},
		icon: function (value, name){
			return $.php.sprintf('<i class="fa fa-%s"></i> %s', value, name);
		},
		jsonStore: function (url){
			return new Ext.data.JsonStore({
				autoLoad : true,  
				root : 'data',
				url : url,
				fields : ['id', 'value']
			});
		},
		isTrue: function(val)
		{
			if(typeof val === 'boolean') return val;
			if(typeof val !== 'string') return false;
			
			return val.match(/^(true|Y|Yes|On|1)$/i);
		},
	
		isFalse: function(val)
		{
			if(typeof val === 'boolean') return val;
			if(typeof val !== 'string') return false;
	
			return val.match(/^(false|N|No|Off|0)$/i);
		}
	};
}( jQuery, Ext, window ));


